import moment from 'moment';

const BUSINESS_DATE_FORMATS = [
  moment.ISO_8601,
  'MMM D YYYY',
  'D MMM YYYY',
  'MM-DD-YYYY',
  'MM/DD/YYYY',
  'ddd MMM D YYYY HH:mm:ss',
];

export const parseBusinessHoursDate = (value) => {
  if (moment.isMoment(value)) {
    return value.isValid() ? value.clone().startOf('day') : null;
  }

  if (value instanceof Date) {
    const parsedDate = moment(value);
    return parsedDate.isValid() ? parsedDate.startOf('day') : null;
  }

  const raw = String(value || '').trim();
  if (!raw) return null;

  let parsed = moment(raw, BUSINESS_DATE_FORMATS, true);
  if (!parsed.isValid()) {
    parsed = moment(new Date(raw));
  }
  return parsed.isValid() ? parsed.startOf('day') : null;
};

export const businessHoursDatePayload = (value) => {
  const parsed = parseBusinessHoursDate(value);
  return parsed ? parsed.format('YYYY-MM-DD') : '';
};
